<template>
	<el-header class="header-container" style='height:80px;'>
		<div class="inner-container">
			<!-- LOGO -->
			<div class="logo" @click="$router.push('/')">
				<img src="@/assets/images/fst1.png" alt="泛思特logo" />
				<div class="sgStyle">
					<p>{{ $t('homeTitle') }}</p>
					<label>{{ $t('homeSubtitle') }}</label>
				</div>
			</div>

			<!-- 桌面菜单 -->
			<el-menu class="desktop-menu" mode="horizontal" :default-active="activeMenu" @select="handleSelect" :router="true"
				active-text-color="#409EFF" text-color="#333">
				<el-menu-item index="/">{{ $t('home') }}</el-menu-item>
				<el-menu-item index="/about">{{ $t('about') }}</el-menu-item>

				<el-submenu index="services">
					<template #title>{{ $t('services') }}</template>
					<el-menu-item :index="'/services/shipping#shipping'"
						@click="navigateTo('shipping')">{{ $t('shipping') }}</el-menu-item>
					<el-menu-item :index="'/services/refrigerated#refrigerated'"
						@click="navigateTo('refrigerated')">{{ $t('refrigerated') }}</el-menu-item>
					<el-menu-item :index="'/services/operable#operable'"
						@click="navigateTo('operable')">{{ $t('operable') }}</el-menu-item>
					<el-menu-item :index="'/services/consultation#consultation'"
						@click="navigateTo('consultation')">{{ $t('consultation') }}</el-menu-item>
				</el-submenu>

				<el-submenu index="contact">
					<template #title>{{ $t('contact') }}</template>
					<el-menu-item index="/contact/business">{{ $t('business') }}</el-menu-item>
					<!-- 仅在语言为中文时显示 招贤纳士 -->
					<el-menu-item v-if="currentLang === 'zh'" index="/contact/careers">{{ $t('recruitment') }}</el-menu-item>
				</el-submenu>

				<!-- <el-submenu index="language">
					<template #title>{{ currentLangLabel }}</template>
					<el-menu-item @click="changeLanguage('zh')">{{ $t('language') }}</el-menu-item>
					<el-menu-item @click="changeLanguage('en')">{{ $t('english') }}</el-menu-item>
				</el-submenu> -->
			</el-menu>

			<!-- 移动菜单按钮 -->
			<div class="mobile-menu-toggle" @click="toggleMobileMenu">
				<i :class="isMobileMenuVisible ? 'el-icon-close' : 'el-icon-menu'"></i>
			</div>
		</div>

		<!-- 移动菜单 -->
		<transition name="slide-fade">
			<div v-if="isMobileMenuVisible" class="mobile-menu">
				<el-menu :default-active="activeMenu" @select="handleSelect" :router="true" active-text-color="#409EFF"
					text-color="#333">
					<el-menu-item index="/">{{ $t('home') }}</el-menu-item>
					<el-menu-item index="/about">{{ $t('about') }}</el-menu-item>
					<el-menu-item index="/services/shipping" @click="navigateTo('shipping')">{{ $t('shipping') }}</el-menu-item>
					<el-menu-item index="/services/refrigerated"
						@click="navigateTo('refrigerated')">{{ $t('refrigerated') }}</el-menu-item>
					<el-menu-item index="/services/operable" @click="navigateTo('operable')">{{ $t('operable') }}</el-menu-item>
					<el-menu-item index="/services/consultation"
						@click="navigateTo('consultation')">{{ $t('consultation') }}</el-menu-item>
					<el-menu-item index="/contact/business">{{ $t('business') }}</el-menu-item>
					<!-- 仅在语言为中文时显示 招贤纳士 -->
					<el-menu-item v-if="currentLang === 'zh'" index="/contact/careers">{{ $t('recruitment') }}</el-menu-item>
					<el-menu-item @click="changeLanguage('zh')">{{ $t('language') }}</el-menu-item>
					<el-menu-item @click="changeLanguage('en')">{{ $t('english') }}</el-menu-item>
				</el-menu>
			</div>
		</transition>
	</el-header>
</template>

<script>
	export default {
		name: 'Header',
		data() {
			return {
				isMobileMenuVisible: false,
				currentLang: localStorage.getItem('lang') || 'zh'
			}
		},
		created() {
			// 自动恢复之前选择的语言
			const savedLang = localStorage.getItem('lang') || 'zh';
			this.changeLanguage(savedLang);
		},
		computed: {
			currentLangLabel() {
				return this.currentLang === 'zh' ? this.$t('language') : this.$t('english')
			},
			activeMenu() {
				const route = this.$route;
				if (route.hash) {
					return `${route.path}${route.hash}`;
				}
				if (route.path === '/contact/business') {
					return '/contact/business';
				}
				if (route.path === '/contact/careers') {
					return '/contact/careers';
				}
				if (route.path.startsWith('/services')) {
					return 'services';
				}
				return route.path;
			}
		},
		methods: {
			toggleMobileMenu() {
				this.isMobileMenuVisible = !this.isMobileMenuVisible;
			},
			handleSelect(index) {
				this.isMobileMenuVisible = false;
			},
			navigateTo(section) {
				this.$router.push({
					path: `/services/${section}`,
					hash: `#${section}`
				});
			},
			changeLanguage(lang) {
				this.currentLang = lang;
				localStorage.setItem('lang', lang); // 保存语言设置到 localStorage
				this.$i18n.locale = lang;
				this.isMobileMenuVisible = false;
			}
		}
	}
</script>

<style scoped lang="scss">
	.header-container {
		background-color: #fff;
		height: 80px;
		padding: 0 20px;
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		z-index: 1000;

		@media (max-width: 768px) {
			height: 70px;
			padding: 0 15px;
		}
	}

	.inner-container {
		display: flex;
		align-items: center;
		justify-content: space-between;
		max-width: 1280px;
		margin: 0 auto;
		height: 100%;
	}

	.logo {
		display: flex;
		align-items: center;
		gap: 12px;
		cursor: pointer;

		img {
			width: 60px;
			object-fit: contain;

			@media (max-width: 768px) {
				width: 48px;
			}
		}

		.sgStyle {
			display: flex;
			flex-direction: column;
			line-height: 1.2;

			p {
				margin: 0;
				font-size: 18px;
				font-weight: bold;
				color: #333;

				@media (max-width: 768px) {
					font-size: 16px;
				}
			}

			label {
				font-size: 13px;
				color: #666;

				@media (max-width: 480px) {
					display: none;
				}
			}
		}
	}

	.desktop-menu {
		// flex: 1;
		display: flex;
		justify-content: center;

		@media (max-width: 768px) {
			display: none;
		}

		.el-menu-item,
		.el-submenu__title {
			height: 80px;
			line-height: 80px;
			padding: 0 20px;
			font-weight: 500;
			transition: all 0.2s ease;

			&:hover {
				color: #409EFF;
				background-color: transparent;
			}
		}

		.el-menu-item.is-active,
		.el-submenu.is-active .el-submenu__title {
			color: #409EFF;
		}
	}

	::v-deep .el-submenu {
		margin: auto 0;
	}

	.mobile-menu-toggle {
		display: none;
		font-size: 24px;
		padding: 10px;
		color: #333;

		@media (max-width: 768px) {
			display: block;
		}
	}

	.mobile-menu {
		background: #fff;
		box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
		border-top: 1px solid #eee;

		.el-menu-item {
			height: 50px;
			line-height: 50px;
			font-size: 15px;
			padding: 0 16px;
		}

		.el-menu-item.is-active {
			color: #409EFF;
			background-color: #f5f9ff;
		}

		@media (min-width: 769px) {
			display: none !important;
		}
	}

	.slide-fade-enter-active,
	.slide-fade-leave-active {
		transition: all 0.3s ease;
	}

	.slide-fade-enter,
	.slide-fade-leave-to {
		opacity: 0;
		transform: translateY(-10px);
	}
</style>